export const Z = {
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  popover: 1350,
  datepicker: 1380,
  snackbar: 1400,
  tooltip: 1500,
} as const;

export type ZIndexToken = keyof typeof Z;
